import React, { useEffect, useState } from "react";
import {
	BaseModal,
	ShipmentItem,
	ItemsDataTable,
} from "../../../../components";
import { TableDisplayData } from "../../../../components/ui/Tables/types";
import {
	useDataTableContext,
	DataTableContextProvider,
} from "../../../../components/ui/Tables/hooks";
import { PageDataProvider, usePageListDetails } from "../../../../hooks";
import { getFontAwesomeIcon } from "../../../../utils";

interface ShippingDetailsModalProps {
	isModalOpen: boolean;
	slug: string;
	uuid: string | null;
}

interface AdditionalData {
	slug?: string;
	uuid?: string;
	salesOrderStageId?: number[];
}

const FulfillmentModal: React.FC<ShippingDetailsModalProps> = ({
	isModalOpen,
	slug: incomingSlug,
	uuid,
}) => {
	const { setModalTableOpened } = useDataTableContext();
	const [hasModalTable, setHasModalTable] = useState<boolean>(false);
	const [pageMetaSlug, setPageMetaSlug] = useState<string>("");
	const [pageTitle, setPageTitle] = useState<string>("");
	const [data, setData] = useState<any[]>([]);
	const [tableDisplayData, setTableDisplayData] = useState<TableDisplayData>(
		{} as TableDisplayData,
	);
	const [resolvedSlug, setResolvedSlug] = useState<string>(incomingSlug);
	useEffect(() => {
		if (!incomingSlug) return;
		setResolvedSlug(incomingSlug);
	}, [incomingSlug]);

	const { pageMeta } = usePageListDetails(
		pageMetaSlug,
		Boolean(pageMetaSlug),
	);

	const [additionalData, setAdditionalData] = useState<AdditionalData>(
		{} as AdditionalData,
	);

	const modalHeader = (
		<div className="flex w-full items-start text-22px font-omnes-regular text-navy-500">
			<h1>Fulfillment</h1>
		</div>
	);
	const modalButtonClassNames =
		"text-xl text-navy-300 hover:text-navy-500 p-2";

	useEffect(() => {
		if (!isModalOpen) {
			// clear out on close
			setAdditionalData({});
			setPageMetaSlug("");
			return;
		}
		const modalUuid = localStorage.getItem("modalUuid");
		const parentUuid = localStorage.getItem("parentUuid");

		if (modalUuid) {
			setAdditionalData({
				slug: "SalesOrderItems.uuid",
				uuid: modalUuid,
			});
			setPageMetaSlug("item-fulfillments-for-sales-order-items");
		} else if (uuid) {
			setAdditionalData({ slug: "SalesOrders.uuid", uuid });
			setPageMetaSlug("item-fulfillments-for-sales-orders");
		} else if (parentUuid) {
			setAdditionalData({ slug: "SalesOrders.uuid", uuid: parentUuid });
			setPageMetaSlug("item-fulfillments-for-sales-orders");
		} else {
			setAdditionalData({});
			setPageMetaSlug("");
		}
	}, [isModalOpen, uuid]);

	const handleClose = () => {
		localStorage.removeItem("modalUuid");

		setModalTableOpened(false);
	};

	return (
		<BaseModal
			onClose={() => {}}
			isOpen={isModalOpen}
			header={modalHeader}
			fromPortal
			containerClassNames="bg-white rounded-lg min-w-[1000px] p-4 "
			altCloseButton={(closeBaseModal) => (
				<button
					onClick={() => {
						handleClose();
						closeBaseModal();
					}}
					className={modalButtonClassNames}
				>
					{getFontAwesomeIcon("xmark", "regular")}
				</button>
			)}
		>
			<PageDataProvider pageMeta={pageMeta} pageTitle={pageTitle}>
				<DataTableContextProvider
					showStickyColumn={false}
					hasModalTable={true}
					data={data}
					hasInfiniteScroll
				>
					<div className="bg-white max-w-[1000px] h-[80vh] ">
						<ItemsDataTable
							key={`${resolvedSlug}-${
								additionalData?.uuid || ""
							}`}
							pageTitle={pageTitle}
							hasModalTable={hasModalTable}
							setPageTitle={setPageTitle}
							setHasModalTable={setHasModalTable}
							slug={resolvedSlug}
							setData={setData}
							additionalData={additionalData}
							tableDisplayData={tableDisplayData}
						/>
					</div>
				</DataTableContextProvider>
			</PageDataProvider>
		</BaseModal>
	);
};

export default FulfillmentModal;
